import { Button } from '@mui/material'
import React, { useState } from 'react'
import { useCustomerContext } from '../CustomerContext'
import { useTheme } from '../../../utils/themeContext'
import { getColorsForTheme } from '../../../global-styles/clientColors'
import { FormDrawerComponent } from 'shared/FormDrawerComponent'
import { InitiateReturnForm } from './InitiateReturnForm'
import { useInitiateVehicleReturn } from './useInitiateVehicleReturn'

export function ReturnVehicleButton() {
  const { subscriptionId, vehicleId, customerId } = useCustomerContext()
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)
  const mutation = useInitiateVehicleReturn()

  const handleSave = async (data: any) => {
    await mutation.mutateAsync(data)
    setIsDrawerOpen(false)
  }

  const getDefaultValues = () => {
    // Get current datetime in local timezone formatted for datetime-local input
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    const localDateTime = `${year}-${month}-${day}T${hours}:${minutes}`

    return {
      vehicleId: vehicleId || '',
      customerId: customerId || '',
      subscriptionId: subscriptionId || '',
      vin: '',
      odometerReading: 0,
      returnTime: localDateTime,
      locationAddress: '',
      missingAssetsAmount: 0,
      initialDamagesAmount: 0,
      miscellaneous: '',
    }
  }

  return (
    <>
      <Button
        color="error"
        onClick={() => setIsDrawerOpen(true)}
        type="button"
        variant="contained"
        sx={{
          backgroundColor: themeColors.buttonColor,
          color: 'black',
          '&:hover': {
            backgroundColor: themeColors.buttonHover,
          },
        }}
      >
        Return Vehicle
      </Button>
      {isDrawerOpen && (
        <FormDrawerComponent
          isDrawerOpen={isDrawerOpen}
          setIsDrawerOpen={setIsDrawerOpen}
          header="Initiate Vehicle Return"
          handleSave={handleSave}
          defaultValues={getDefaultValues()}
          submitButtonLabel="Complete Return"
          form={({ errors, control }) => (
            <InitiateReturnForm errors={errors} control={control} />
          )}
        />
      )}
    </>
  )
}
